"use client"

import * as React from "react"
import { Link } from "react-router-dom"

import { ArrowLeftIcon } from "@/components/ui/arrow-left-icon"
import {
  renderRouteIconWithAnimRef,
  sidebarNavIconShellClass,
  useSidebarNavIconAnimation,
} from "@/components/Sidebar/sidebarNavIconAnimation"
import {
  SidebarMenuButton,
  SidebarMenuItem,
  useCloseMobileSidebar,
} from "@/components/ui/sidebar"
import { notificationsCentreIconRailButtonClass } from "@/constants/sidebarChrome"
import { cn } from "@/lib/utils"

const navSidebarBackExpandedButton =
  "group-data-[state=expanded]:h-10 group-data-[state=expanded]:gap-2.5 group-data-[state=expanded]:text-[0.9375rem] group-data-[state=expanded]:leading-snug group-data-[state=expanded]:[&_svg]:size-5"

const navSidebarBackLabelClass =
  "truncate transition-[opacity,margin,max-width] duration-200 ease-linear group-data-[collapsible=icon]:max-w-0 group-data-[collapsible=icon]:opacity-0 group-data-[collapsible=icon]:overflow-hidden"

export function NavSidebarBackItem({
  returnPath,
  onNavigate,
  iconRailOnly = false,
}: {
  returnPath: string
  onNavigate: () => void
  iconRailOnly?: boolean
}) {
  const { iconAnimRef, linkHandlers } = useSidebarNavIconAnimation()
  const closeMobileSidebar = useCloseMobileSidebar()

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        className={
          iconRailOnly
            ? notificationsCentreIconRailButtonClass
            : navSidebarBackExpandedButton
        }
      >
        <Link
          to={returnPath}
          onClick={() => {
            closeMobileSidebar()
            onNavigate()
          }}
          {...linkHandlers}
        >
          <span className={sidebarNavIconShellClass}>
            {renderRouteIconWithAnimRef(
              <ArrowLeftIcon size={16} className="text-inherit" aria-hidden />,
              iconAnimRef
            )}
          </span>
          <span className={cn(iconRailOnly ? "sr-only" : navSidebarBackLabelClass)}>
            Back
          </span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
